<template>
	<div class="modal-wrap">
		<div class="modal-content">
			<img v-if="showClose" src="@/assets/images/order-manage/ic_order_off.png" class="close-icon" @click="onCloseClick">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'commonmodal',
  props: {
    showClose: {
      type: Boolean,
    },
    isShowModal: {
      type: Boolean,
    }
  },

  methods: {
    onCloseClick() {
      this.$emit('close-modal');
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variable.less';
@import '~@/assets/styles/handleMethods.less';
@import '~@/assets/styles/reset.css';
.modal-wrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background:rgba(0,0,0,0.6);
  display: flex;
  justify-content: center;
  align-items: center; 
  z-index: 12;
  .close-icon {
    .w(12);
    .h(12);
    position: relative;
    .t(-105);
    .t(15);
    right: -7.64rem;
    top: 0.9rem;
  }
}
</style>
